import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { ModalCard } from 'partial/components/Modal';
import AsyncButton from 'modules/common/components/AsyncButton';

import { useEditStatus } from '../hooks';

const Status = ({ onClose, data, setShown }) => {
  const [pending, setPending] = useState(false);
  const status = data?.is_active;

  const onError = () => setPending(false);

  const onSuccess = () => {
    setPending(false);
    setShown(false);
    onClose();
  };

  const [loading, edit] = useEditStatus(onSuccess, onError);
  const isLoading = loading || pending;

  const handleStatus = () => {
    setPending(true);
    edit({
      id: data?.uuid,
    });
  };

  return (
    <ModalCard
      size="sm"
      title={`${!status ? 'ACTIVATE' : 'DEACTIVATE'} USER`}
      onClose={onClose}
    >
      <div className="p-4 pt-2">
        <h5 className="pb-10 font-light">
          Are you sure you want to {!status ? 'activate' : 'deactivate'} &apos;
          <span className="text-brand-600 capitalize">
            {data?.profile?.first_name} {data?.profile?.last_name}
          </span>
          &apos;?
        </h5>
        <div className="flex justify-end gap-2 pt-4 border-t border-neutral-200">
          <AsyncButton
            color="outline"
            className="font-[400] !text-neutral-500"
            onClick={onClose}
          >
            Cancel
          </AsyncButton>
          <AsyncButton
            type="button"
            color="outline"
            className="font-[400]"
            onClick={handleStatus}
            disabled={isLoading}
            isLoading={isLoading}
          >
            confirm
          </AsyncButton>
        </div>
      </div>
    </ModalCard>
  );
};

Status.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  onClose: PropTypes.func.isRequired,
  setShown: PropTypes.func.isRequired,
};

export default Status;
